import { lazy } from 'react';

import TermsDialog from 'components/elements/TermsDialog';
import MainLayout from 'components/layout/MainLayout';
import Loadable from 'components/ui/Loadable';
import AuthGuard from 'utils/routeGuard/AuthGuard';

const CampaignListPage = Loadable(
  lazy(() => import('components/pages/CampaignList'))
);
const CampaignPage = Loadable(
  lazy(() => import('components/pages/CampaignPage'))
);
const KioskSearchPage = Loadable(
  lazy(() => import('components/pages/KioskSearch'))
);
const NewCampaignPage = Loadable(
  lazy(() => import('components/pages/NewCampaign'))
);
const ArtDesignBriefPage = Loadable(
  lazy(() => import('components/pages/ArtDesignBriefPage'))
);
const PaymentMethodPage = Loadable(
  lazy(() => import('components/pages/PaymentMethodPage'))
);
const DesignBriefApprovalPage = Loadable(
  lazy(() => import('components/pages/DesignBriefApprovalPage'))
);
const ProfilePage = Loadable(
  lazy(() => import('components/pages/ProfilePage'))
);
const TermsAndConditionsPage = Loadable(
  lazy(() => import('components/pages/TermsAndConditions'))
);
const SupportTicketsPage = Loadable(
  lazy(() => import('components/pages/SupportTicketsPage'))
);

// ===========================|| MAIN ROUTING ||=========================== //

const LoggedInRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <TermsDialog />
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/',
      element: <CampaignListPage />,
    },
    {
      path: '/new-campaign',
      element: <NewCampaignPage />,
    },
    {
      path: '/campaign/:campaign',
      element: <CampaignPage />,
    },
    {
      path: '/campaign/:campaign/payment-method',
      element: <PaymentMethodPage />,
    },
    {
      path: '/campaign/:campaign/design-brief-approval',
      element: <DesignBriefApprovalPage />,
    },
    {
      path: '/campaign/:campaign/design-brief-create',
      element: <ArtDesignBriefPage />,
    },
    {
      path: '/kiosk-search',
      element: <KioskSearchPage />,
    },
    { path: '/profile', element: <ProfilePage /> },
    {
      path: '/terms-and-conditions',
      element: <TermsAndConditionsPage />,
    },
    {
      path: '/support-tickets',
      element: <SupportTicketsPage />,
    },
  ],
};

export default LoggedInRoutes;
